import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import login from "../../assets/images/user.svg";
import { logoutAction } from "../../containers/login/actions";
import SubscriptionTag from "./SubscriptionTag";
import { showFixedLength, stringLength } from "../../utils/commonFunctions";
import AdminButton from "./adminButton";
import { HeaderSlugs } from "../../enum/user";

function MobileLoginModal({ showMobileDropdown, setShwoMobileDropdown, isAdmin }) {
  const userDetail = useSelector((state) => state?.my_account?.user_info);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleClickLogout = () => {
    dispatch(logoutAction(history));
  };
  const truncateName = showFixedLength(userDetail?.name, 25) + stringLength(userDetail?.name, 25);

  return (
    <Modal centered show={showMobileDropdown}>
      <Modal.Body className="position-relative">
        <i aria-hidden className="p-2 fs-6 fa-regular fa-xmark position-absolute top-0 end-0" onClick={() => setShwoMobileDropdown(false)} />
        <div className={`text-darkblue text-center ${showMobileDropdown && "show"}`}>
          <img
            className="mt-3 mb-3 rounded-circle"
            height="100"
            width="100"
            src={userDetail?.photo ? userDetail?.photo : login}
            alt="logo"
            // onError={getImageError}
          />

          <h6 title={userDetail?.name}>{truncateName || ""}</h6>
          <p className="fw-400 mb-0 text-lg">{userDetail?.email}</p>
          <div>
            <SubscriptionTag subscriptionType={userDetail?.subscription_type} />
          </div>
          <div className="border-top p-3">
            <div className="mb-2 d-flex flex-column gap-2 align-items-start">
              <a href="/my-account" className="d-flex gap-2 align-items-center">
                <i className="fa-fw fa-light fa-user-pen" /> <span aria-hidden>Manage your account</span>
              </a>
              {isAdmin ? (
                <AdminButton isUserSide title="Switch to Website" link={HeaderSlugs?.User} />
              ) : (
                <AdminButton isUserSide title="Go to Admin" link={HeaderSlugs?.Admin} />
              )}
              <div aria-hidden onClick={handleClickLogout} className="cursor-pointer d-flex align-items-center gap-2 text-danger">
                <i className="fa-fw fa-light fa-arrow-right-from-bracket" /> Logout
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default MobileLoginModal;
